import { Component, OnInit } from '@angular/core';
import { DatePipe } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { forkJoin } from 'rxjs';
import { SharedService } from 'src/app/service/shared/shared.service';
import { HttpService } from 'src/app/service/http/http.service';
import { GenericService } from 'src/app/services/genericService/generic.service';
import { GetCompanyAndUsersData } from 'src/app/services/get-company-and-users-data/get-company-and-users-data.service';
import { DwmGenericServiceService, TableState } from '../../_DWM-Generic-Services/generic-service.service';
import { CommentDialogueComponent } from '../../_DWM-Generic-Components/comment-dialogue/comment-dialogue.component';
import * as CommonFunctions from 'src/app/shared/commen-function-file';
import { Config } from 'src/app/app-constant';
import { TimeOnlyPipePipe } from 'src/app/shared/pipe/time-only-pipe.pipe';
import { AllPopupModalExecutionServiceService } from 'src/app/shared/services/all-popup-modal-execution-service.service';
import { CopypreviousmonthpopupComponent } from '../../dwm-popups/copypreviousmonthpopup/copypreviousmonthpopup.component';

@Component({
  selector: 'app-approve-team-dwm',
  templateUrl: './approve-team-dwm.component.html',
  styleUrls: ['./approve-team-dwm.component.scss']
})
export class ApproveTeamDwmComponent implements OnInit {
  commonFunctions = CommonFunctions;
  loggedInUserCompanyID: any;
  loggedInUserId: any;
  monthsList: string[] = [];
  isAllSelected = false;
  today: Date = new Date();

  tableState!: TableState<any>;

  selectedFilters: any = {
    selectedEmpId: null,
    selectedYear: null,
    selectedMonth: null,
    searchString: null,
    selectedDwmType: 'Monthly',
    isCutoffTaskEditable: null
  };

  listOfYears: any = [];

  dwmManagerUser: any = null;
  dwmUsers: any = null;
  dwmUserTaskList: any = [];
  teamTableHeaders: { label: string; key: string }[] = [
    { label: 'Dwm type', key: 'dwmType' },
    { label: 'Category', key: 'categoryName' },
    { label: 'Actionable', key: 'actionable' },
    { label: 'Time From', key: 'timeFrom' },
    { label: 'Time To', key: 'timeTo' },
    { label: 'Repeat', key: 'isRepetativeTask' },
    { label: 'Frequency', key: 'dwmFrequency' },
    { label: 'Date', key: 'dwmDate' },
    { label: 'Criticality', key: 'isCriticalTask' },
    { label: 'Status', key: 'dwmStatus' },
    { label: 'Action', key: 'action' }
  ];

  dwmCategories: any = null;
  selectedTaskList: any = [];
  // formatedataVariable = CommonFunctions.formatText;
  checkIfIsRNDOrL4AndAboveEmployee: any = null;
  getAllDwmTypes: any = [];
  getMonthalyFrequency: any = this.dwmGenericServiceService.getFrequency('Monthly') || [];
  getMonthalyFrequencyForL4AndAbove: any = this.dwmGenericServiceService.getFrequency('Monthly', true) || [];
  getAnuallyFrequency: any = this.dwmGenericServiceService.getFrequency('Annually') || [];

  cuttoffDetails: { getCurrentCuttOffDate: Date | null; getCurrentCuttOffDateInMs: number | null } | null = {
    getCurrentCuttOffDate: null,
    getCurrentCuttOffDateInMs: null
  };
  showCopyButton = true;

  constructor(
    public sharedService: SharedService,
    private httpService: HttpService,
    private config: Config,
    public dialog: MatDialog,
    private toastr: ToastrService,
    public genericService: GenericService,
    private datePipe: DatePipe,
    private timeOnlyPipePipe: TimeOnlyPipePipe,
    public dwmGenericServiceService: DwmGenericServiceService,
    public getCompanyAndUsersData: GetCompanyAndUsersData,
    private allPopupModalExecutionServiceService: AllPopupModalExecutionServiceService
  ) {}

  ngOnInit() {
    this.dwmGenericServiceService.getDWMSetup().subscribe((res: any) => {
      this.cuttoffDetails = this.dwmGenericServiceService.checkGetDWMSetup(res);
    });

    this.loggedInUserCompanyID = this.getCompanyAndUsersData.loggedInUserCompanyID;
    this.loggedInUserId = this.getCompanyAndUsersData.loggedInUserId;

    this.monthsList = this.genericService.allMonth;
    this.selectedFilters.selectedYear = this.selectedYear();
    this.listOfYears = this.getCompanyAndUsersData.getAllFinancialYears;
    this.selectedFilters.selectedMonth = this.genericService.getCurrentMonth();

    this.generateData();
  }

  selectedYear() {
    return this.getCompanyAndUsersData.convertFinancialYear(this.getCompanyAndUsersData?.loggedInCompanyFiscalyear || '', 'yearTextToNumber', '_');
  }

  generateData() {
    this.resetAllSelectedTasks();
    this.dwmUserTaskList = [];
    this.tableState = this.dwmGenericServiceService.init([], this.pageSize);
    this.checkIfIsRNDOrL4AndAboveEmployee = this.getCompanyAndUsersData.checkIfIsRNDOrL4AndAboveEmployee(this.selectedFilters?.selectedEmpId);
    this.getAllDwmTypes = this.dwmGenericServiceService.getDwmType(this.checkIfIsRNDOrL4AndAboveEmployee.isL4AndAbove);

    const getStartAndEdnDate = this.selectedFilters.selectedDwmType == 'Annually' ?  this.getCompanyAndUsersData.getFullFinancialYearRange(this.selectedFilters.selectedYear, this.getCompanyAndUsersData.loggedInCompanyFiscalyear || '') : this.getCompanyAndUsersData.getDateRangeAsPerSelectedFinancialYearAndMonth(this.selectedFilters.selectedYear, this.selectedFilters.selectedMonth);

    const request = {
      companyId: this.loggedInUserCompanyID,
      userId: this.loggedInUserId,
      from: getStartAndEdnDate.startDate,
      to: getStartAndEdnDate.endDate,
      date: null,
      toYear: null,
      fromYear: null,
      userType: null,
      yearRange: null
    };

    this.selectedFilters.isCutoffTaskEditable = this.dwmGenericServiceService.isCreateTaskEnabled(getStartAndEdnDate.endDate, this.cuttoffDetails?.getCurrentCuttOffDate);

    forkJoin({
      // getTeamMembers: this.httpService.callPostService(this.config.getTeamOfManagerForDWm, request),
      getTeamMembers: this.httpService.callGetService(`${this.config.getExitedEmployeeUnderManager}?companyId=${this.loggedInUserCompanyID}&managerCode=${this.getCompanyAndUsersData.loggedInUserEmpCode}`),
      dwmMasterData: this.httpService.callGetService(`${this.config.getDwmMaster}?companyId=${this.loggedInUserCompanyID}`),
      getCategoriesList: this.httpService.callGetService(`${this.config.getCategoriesList}?companyId=${this.loggedInUserCompanyID}`)
    }).subscribe({
      next: (data: any) => {
        // console.log(data.getCategoriesList);
        // this.dwmManagerUser = data?.getTeamMembers?.status ? data?.getTeamMembers?.data : [];
        this.dwmManagerUser = data?.getTeamMembers?.status ? data.getTeamMembers.data.map((u: any) => ({ ...u, id: Number(u.id) })) : [];

        this.dwmUsers = data?.dwmMasterData?.status ? this.dwmGenericServiceService.sortByIdDesc(data?.dwmMasterData?.data) : [];
        // this.dwmCategories = data?.getCategoriesList?.status ? data?.getCategoriesList?.data : [];
        this.dwmCategories = data?.getCategoriesList?.status ? data?.getCategoriesList?.data.map((item: any) => ({ ...item, categoryName: item.categoryName?.trim() })).filter((item: any) => (this.checkIfIsRNDOrL4AndAboveEmployee.isRnd ? true : item.categoryName !== 'R&D')) : [];

        // console.log('this.dwmManagerUser - - - - ', data.dwmMasterData.data);

        // collect all team user IDs
        const teamUserIds = this.dwmManagerUser.map((user: any) => user.id);
        const filteredDwmData = this.dwmUsers.filter((dwm: any) => teamUserIds.includes(dwm.userId));

        filteredDwmData.forEach((filteredDwmData: any) => {
          const getDataAsPerMonthAndYear = this.getCompanyAndUsersData.getDateInMs(getStartAndEdnDate.startDate) <= this.getCompanyAndUsersData.getDateInMs(filteredDwmData?.dwmDate) && this.getCompanyAndUsersData.getDateInMs(getStartAndEdnDate.endDate) >= this.getCompanyAndUsersData.getDateInMs(filteredDwmData?.dwmDate);

          // if (filteredDwmData?.dwmStatus == 'Pending' && filteredDwmData?.userId == this.selectedFilters.selectedEmpId && getDataAsPerMonthAndYear && filteredDwmData?.dwmType == this.selectedFilters.selectedDwmType) {
          if (filteredDwmData?.dwmStatus == 'Pending' && filteredDwmData?.userId == this.selectedFilters.selectedEmpId && filteredDwmData?.managerId == this.loggedInUserId && getDataAsPerMonthAndYear && (!this.selectedFilters.selectedDwmType || filteredDwmData?.dwmType === this.selectedFilters.selectedDwmType)) {
            this.dwmUserTaskList.push({
              checkboxCheck: false,
              categoryName: this.dwmCategories.find((cat: any) => cat.categoryId === filteredDwmData?.categoryId)?.categoryName || '',

              userId: filteredDwmData?.userId || '',
              dwmType: filteredDwmData?.dwmType || '',
              checkIfIsRNDEmployee: this.checkIfIsRNDOrL4AndAboveEmployee.isRnd,
              checkIfIsL4AndAboveEmployee: this.checkIfIsRNDOrL4AndAboveEmployee.isL4AndAbove,
              categoryId: filteredDwmData?.categoryId || '',
              actionable: filteredDwmData?.actionable || '',
              timeFrom: filteredDwmData?.timeFrom || '',
              timeTo: filteredDwmData?.timeTo || '',
              dwmFrequency: filteredDwmData?.dwmFrequency?.toUpperCase()?.replace('_', '-') || '',
              dwmMonth: filteredDwmData?.dwmMonth || '',
              isCriticalTask: filteredDwmData?.isCriticalTask || '',
              dwmStatus: filteredDwmData?.dwmStatus,
              managerComments: filteredDwmData?.managerComments || '',
              managerId: filteredDwmData?.managerId || '',
              dwmDate: filteredDwmData?.dwmDate || '',

              companyId: filteredDwmData?.companyId || '',
              dwmActive: filteredDwmData?.dwmActive || '',
              dwmYear: filteredDwmData?.dwmYear || '',
              empComments: filteredDwmData?.empComments || '',
              fiscalYear: filteredDwmData?.fiscalYear || '',
              id: filteredDwmData?.id || '',
              isRepetativeTask: filteredDwmData?.isRepetativeTask,
              isCutoffTaskEditable: this.dwmGenericServiceService.isCreateTaskEnabled(filteredDwmData?.dwmDate, this.cuttoffDetails?.getCurrentCuttOffDate)
            });
          }
        });

        // Initialize table
        this.tableState = this.dwmGenericServiceService.init(this.dwmUserTaskList, this.pageSize);
      }
    });
  }

  applyDataFilters(event: any, filterName: any, applyFilter: boolean = true) {
    if (applyFilter) {
      this.selectedFilters[filterName] = event;
    } else {
      this.selectedFilters = {
        selectedEmpId: null,
        selectedYear: this.selectedYear(),
        selectedMonth: this.genericService.getCurrentMonth(),
        searchString: null,
        selectedDwmType: 'Monthly'
      };
    }
    // if (filterName != 'selectedDwmType') {
    //   this.generateData();
    //   this.isAllSelected = false;
    // }
    this.generateData();
    this.isAllSelected = false;
    this.showCopyButton = this.dwmGenericServiceService.isCurrentOrPreviousMonth(this.selectedFilters.selectedMonth);
  }

  hasNewEntry = false;
  selectALLDwms(event: any, paginatedData: any) {
    this.hasNewEntry = false;
    this.selectedTaskList = [];

    paginatedData.forEach((record: any) => (record.checkboxCheck = false));
    if (event?.checked) {
      paginatedData.forEach((record: any, index: number) => {
        if (record?.dwmStatus == 'Pending') {
          record.checkboxCheck = true;
          this.selectedTaskList.push({ index, item: record });
        }
      });
    }

    this.isAllSelected = event?.checked ?? false;
    this.hasNewEntry = this.selectedTaskList.some((x: any) => x.item?.isNew === true);
  }

  selectSingleDwm(event: any, item: any, index: number) {
    this.hasNewEntry = false;
    if (event?.checked) {
      if (!this.selectedTaskList.some((t: any) => t.item.id === item.id)) {
        this.selectedTaskList.push({ index, item });
      }
    } else {
      this.selectedTaskList = this.selectedTaskList.filter((task: any) => task?.item?.id !== item?.id);
    }
    this.isAllSelected = this.paginatedData?.length > 0 && this.paginatedData.every(r => r?.checkboxCheck || r?.dwmStatus !== 'Pending');
    this.hasNewEntry = this.selectedTaskList.some((x: any) => x.item?.isNew === true);
  }

  approvalAllDwms() {
    if (!this.selectedTaskList?.length) {
      this.toastr.warning('Please select at least one task');
      return;
    }

    const records = this.selectedTaskList.map((x: any) => x.item);
    const newRecords = records.filter((newRecord: any) => newRecord?.isNew);
    const oldRecords = records.filter((oldRecord: any) => !oldRecord?.isNew);

    this.allPopupModalExecutionServiceService
      .confirmationPopupComponentExe({ msg: `Are you sure you want to Save/Approve selected tasks?` })
      .afterClosed()
      .subscribe((confirmed: any) => {
        if (confirmed) {
          if (newRecords?.length) this.saveNewTaskApi(newRecords);
          if (oldRecords?.length) this.updateStatusApiCall(oldRecords, 'Approved');
        }
      });
  }

  approveOrRejectDwm(rowData: any, type: string, index?: any) {
    if (type == 'Rejected') {
      this.dialog
        .open(CommentDialogueComponent, { data: type })
        .afterClosed()
        .subscribe((comment: string) => {
          if (comment) this.updateStatusApiCall([rowData], type, comment);
        });
    } else {
      this.allPopupModalExecutionServiceService
        .confirmationPopupComponentExe({ msg: `Are you sure you want to Approve the tasks.` })
        .afterClosed()
        .subscribe((confirmed: any) => {
          if (confirmed) this.updateStatusApiCall([rowData], type);
        });
    }
  }

  updateStatusApiCall(tasks: any[], status: string, comment = '') {
    const payload = tasks.map((task: any) => ({
      dwmMasterId: task.id,
      companyId: task.companyId,

      categoryId: this.dwmCategories.find((cat: any) => cat.categoryName === task?.categoryName)?.categoryId ?? null,
      actionable: task?.actionable,
      timeFrom: task?.timeFrom,
      timeTo: task?.timeTo,
      dwmFrequency: task?.dwmFrequency ? task?.dwmFrequency?.toUpperCase()?.replace('-', '_') : null,
      dwmMonth: task?.dwmMonth,
      dwmDate: task?.dwmDate ? this.dwmGenericServiceService.formatDate(task.dwmDate) : null,

      managerId: +this.loggedInUserId,
      dwmStatus: status, //Rejected, Approved
      isCriticalTask: task.isCriticalTask ? true : false,
      managerComments: comment || task.managerComments
    }));

    this.httpService.callPostService(this.config.approveOrRejectTask, payload).subscribe({
      next: (data: any) => {
        if (!data?.status) {
          this.toastr.error(data.message);
          return;
        }
        this.updateMultipleTasksInTableState(data?.data);
        this.paginatedData.forEach(r => (r.checkboxCheck = false));
        this.resetAllSelectedTasks();
        this.toastr.success(data.message);
      }
    });
  }

  private updateMultipleTasksInTableState(updatedRows: any[]) {
    const map = new Map<number, any>();
    updatedRows.forEach(r => map.set(r.dwmMasterId ?? r.id, r));

    const update = (list: any[]) => {
      list.forEach(item => {
        const updated = map.get(item.id);
        if (updated) {
          item.dwmStatus = updated.dwmStatus;
          item.managerComments = updated.managerComments;
        }
      });
    };

    update(this.tableState.originalData);
    update(this.tableState.filteredData);
  }

  downloadReport(downloadType: string) {
    const source = this.tableState?.filteredData || [];

    if (!source?.length) {
      this.toastr.warning('No task data to export!');
      return;
    }

    if (downloadType === 'excel') {
      const data = source.map(task => {
        return {
          'Dwm type': task?.dwmType || '',
          Category: task?.categoryName || '',
          Actionable: task?.actionable || '',
          'Time From': task?.timeFrom ? this.timeOnlyPipePipe.transform(task.timeFrom) : '',
          'Time To': task?.timeTo ? this.timeOnlyPipePipe.transform(task.timeTo) : '',

          Repeat: task?.isRepetativeTask ? 'Yes' : 'No',
          Frequency: task?.dwmFrequency || '',
          Calendar: task?.dwmDate ? this.datePipe.transform(task?.dwmDate, 'longDate') : '',
          Criticality: task?.isCriticalTask ? 'Yes' : 'No',
          Status: task?.dwmStatus ? this.dwmGenericServiceService.getStatusLabel(task.dwmStatus) : ''
        };
      });
      this.dwmGenericServiceService.saveAsExcelFile(data, 'Approve Team DWM', 'approve_team_dwm');
    }

    if (downloadType === 'pdf') {
      let pdfTableHeaders: string[] = [];
      this.teamTableHeaders.map((header: any) => {
        if (header?.label !== 'Action') pdfTableHeaders.push(header.label);
      });
      const data = source.map(task => {
        return [task?.dwmType || '', task?.categoryName || '', task?.actionable || '', task?.timeFrom ? this.timeOnlyPipePipe.transform(task.timeFrom) : '', task?.timeTo ? this.timeOnlyPipePipe.transform(task.timeTo) : '', task?.isRepetativeTask ? 'Yes' : 'No', task?.dwmFrequency || '', task?.dwmDate ? this.datePipe.transform(task?.dwmDate, 'longDate') : '', task?.isCriticalTask ? 'Yes' : 'No', task?.dwmStatus ? this.dwmGenericServiceService.getStatusLabel(task.dwmStatus) : ''];
      });
      this.dwmGenericServiceService.downloadTableAsPdf(pdfTableHeaders, data, 'Approve Team DWM', 'approve_team_dwm');
    }
  }

  resetAllSelectedTasks() {
    this.selectedTaskList = [];
    this.isAllSelected = false;
  }
  /* Filers */
  onSearch(event: Event | null) {
    const value = (event?.target as HTMLInputElement)?.value || '';
    this.tableState = this.dwmGenericServiceService.applyFilter(this.tableState, value);
    this.resetAllSelectedTasks();
  }
  onSort(column: string) {
    this.tableState = this.dwmGenericServiceService.sort(this.tableState, column);
  }
  changePage(page: number) {
    this.tableState = this.dwmGenericServiceService.changePage(this.tableState, page);
    this.resetAllSelectedTasks();
  }
  changePageSize(size: number): void {
    this.tableState = this.dwmGenericServiceService.changePageSize(this.tableState, size);
    this.resetAllSelectedTasks();
  }

  get paginatedData() {
    if (!this.tableState) return [];
    return this.dwmGenericServiceService.paginate(this.tableState);
  }

  get totalEntries() {
    return this.dwmGenericServiceService.totalEntries(this.tableState);
  }

  get totalPages() {
    return this.dwmGenericServiceService.totalPages(this.tableState);
  }

  get startEntry() {
    return this.dwmGenericServiceService.startEntry(this.tableState);
  }

  get endEntry() {
    return this.dwmGenericServiceService.endEntry(this.tableState);
  }

  get currentPage(): number {
    return this.tableState?.currentPage ?? 1;
  }

  get pageSize(): number {
    return this.tableState?.pageSize ?? 25;
  }
  /* End Filers */

  // Additional On change filters

  checkMaxLength(data: any) {
    this.dwmGenericServiceService.checkMaxLength(data);
  }

  addNewTask(paginatedData: any) {
    paginatedData.unshift({
      id: this.dwmGenericServiceService.generateUniqueIdByExistingList(paginatedData),
      isNew: true,
      checkboxCheck: false,
      userId: this.selectedFilters.selectedEmpId,
      managerId: +this.loggedInUserId,
      companyId: this.getCompanyAndUsersData.loggedInUserCompanyID,
      dwmYear: this.getCompanyAndUsersData.getYearAsPerSelectedFinancialYearAnddMonth(this.selectedFilters.selectedYear, this.selectedFilters.selectedMonth),
      fiscalYear: this.getCompanyAndUsersData?.loggedInCompanyFiscalyear,
      empComments: null,

      dwmType: this.selectedFilters.selectedDwmType,
      dwmFrequency: null,
      isRepetativeTask: true,

      dwmMonth: null,
      categoryId: null,
      dwmDate: null,
      timeFrom: '',
      timeTo: '',
      actionable: null,
      isCriticalTask: null,
      dwmStatus: 'Pending',
      managerComments: null,

      categoryName: null,
      checkIfIsRNDEmployee: this.checkIfIsRNDOrL4AndAboveEmployee.isRnd,
      checkIfIsL4AndAboveEmployee: this.checkIfIsRNDOrL4AndAboveEmployee.isL4AndAbove,
      isRequiredCategory: false,
      isRequiredActionable: false,
      isRequiredDwmDate: false,
      isCutoffTaskEditable: true
    });

    this.selectedTaskList = [];
    this.isAllSelected = false;
    this.dwmUserTaskList = paginatedData;
    this.tableState = this.dwmGenericServiceService.init(this.dwmUserTaskList, this.pageSize);
  }

  removeTask(paginatedData: any, index: any) {
    this.allPopupModalExecutionServiceService
      .confirmationPopupComponentExe({ msg: `Are you sure you want to discard the changes?` })
      .afterClosed()
      .subscribe((confirmed: any) => {
        if (confirmed) {
          paginatedData.splice(index, 1);
          this.dwmUserTaskList = paginatedData;
          this.tableState = this.dwmGenericServiceService.init(this.dwmUserTaskList, this.pageSize);
        }
      });
  }

  verifyNewTask(items: any) {
    let hasError = false;
    let payload: any[] = [];
    if (!items?.length) return;

    for (const item of items) {
      const result = this.saveNewTaskPayload(item);
      if (!result && !hasError) {
        hasError = true;
      }
      payload.push(result);
    }
    if (hasError) {
      if (!this.toastr.toasts.some((t: any) => t.toastType === 'error')) {
        this.toastr.error('Category and Actionable are mandatory');
      }
      return [];
    }

    // API CALL
    return payload;
  }
  saveNewTaskPayload(item: any) {
    const categoryId = this.dwmCategories.find((cat: any) => cat.categoryName === item?.categoryName)?.categoryId ?? null;

    item.isRequiredCategory = !categoryId;
    item.isRequiredActionable = !item?.actionable;
    item.isRequiredDwmDate = !item?.dwmDate;
    item.isRequiredFrequency = item?.isRepetativeTask ? !item?.dwmFrequency || false : false;
    if (!item?.checkIfIsL4AndAboveEmployee) {
      item.isRequiredTimeFrom = item?.dwmFrequency === 'HOURLY' && !item?.timeFrom;
      item.isRequiredTimeTo = item?.dwmFrequency === 'HOURLY' && !item?.timeTo;
      if (item?.isRequiredTimeFrom || item?.isRequiredTimeTo) return null;
    }
    // console.log(item.isRepetativeTask, item.isRequiredCategory, item.isRequiredActionable, item.isRequiredDwmDate, item.isRequiredTimeFrom, item.isRequiredTimeTo, item?.isRequiredFrequency, item?.dwmFrequency);

    if (item.isRequiredCategory || item.isRequiredActionable || item.isRequiredDwmDate || item.isRequiredFrequency) return null;

    return {
      dwmType: item.dwmType,
      dwmFrequency: item?.isRepetativeTask ? (Array.isArray(item?.dwmFrequency) ? null : item?.dwmFrequency?.toUpperCase()?.replace('-', '_')) : null,
      userId: item.userId,
      managerId: item.managerId,
      companyId: item.companyId,
      categoryId: categoryId,
      dwmYear: item.dwmYear,
      fiscalYear: item.fiscalYear,
      dwmMonth: this.genericService.getCurrentMonthInNumber(this.selectedFilters.selectedMonth),
      dwmDate: item?.dwmDate ? this.dwmGenericServiceService.formatDate(item?.dwmDate) : null,
      timeFrom: item?.timeFrom || null,
      timeTo: item?.timeTo || null,
      actionable: item.actionable,
      isRepetativeTask: item.isRepetativeTask,
      empComments: item.empComments,
      isCriticalTask: item?.isCriticalTask ?? false
    };
  }

  saveNewTask(items: any) {
    this.allPopupModalExecutionServiceService
      .confirmationPopupComponentExe({ msg: `Are you sure you want to save these changes?` })
      .afterClosed()
      .subscribe((confirmed: any) => {
        if (confirmed) {
          this.saveNewTaskApi(items);
        }
      });
  }

  saveNewTaskApi(items: any) {
    console.log('payload - - - ', items);
    const payload: any = this.verifyNewTask(items);
    if (payload?.length)
      this.httpService.callPostService(this.config.mangCreateTaskForEmp, payload).subscribe({
        next: (data: any) => {
          if (data.status) {
            this.toastr.success(data.message);
            this.generateData();
          }
        },
        error: (err: any) => {
          if (err?.error?.message) {
            this.toastr.warning(err.error.message);
          } else {
            this.toastr.error('Something went wrong. Please try again.');
          }
        }
      });
  }

  openCopyPreviousMonthPopup() {
    if (!this.selectedTaskList.length) {
      this.toastr.warning('Please select at least one task to copy', 'Warning');
      return;
    }
    const allItems = this.selectedTaskList.map((x: any) => x.item);

    const dialogRef = this.dialog.open(CopypreviousmonthpopupComponent, {
      maxWidth: '767px',
      panelClass: ['phi_mdc_dialog__container_100_phi_mdc_dialog__content_85_vh'],
      data: { selectedTasks: allItems }
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result?.length) {
        this.copyTasksApiCall(result, 'Tasks copied successfully');
      }
    });
  }

  copyTasksApiCall(payload: any, successMessage = 'Saved as Draft') {
    // this.saveNewTaskApi(payload);
    this.httpService.callPostService(this.config.copyTask, payload).subscribe({
      next: (res: any) => {
        this.toastr.success(successMessage, 'Success');
        this.generateData();
      },
      error: (err: any) => {
        const errorMsg = err?.error?.message || 'Save failed';
        this.toastr.warning(errorMsg, 'Warning');
      }
    });
  }
}
